import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetPriceChangeItems($input: GetPriceChangeItemsInput!) {
    priceChange {
      getPriceChangeItems(input: $input) {
        ... on GetPriceChangeItemsSuccess {
          priceChangeItems {
            id
            product {
              ...PriceChangeProductFields
            }
            groups {
              ...PriceChangeItemGroupFields
            }
          }
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GetPriceChangeItemsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangeFilterOptions($input: GetPriceChangeFilterOptionsInput!) {
    priceChange {
      getPriceChangeFilterOptions(input: $input) {
        ... on GetPriceChangeFilterOptionsSuccess {
          filterOptions {
            suppliers {
              ...PriceChangeFilterOptionBaseFields
            }
            customers {
              ...PriceChangeFilterOptionBaseFields
            }
            productCategories {
              ...PriceChangeFilterOptionBaseFields
            }
            productClasses {
              ...PriceChangeFilterOptionBaseFields
            }
            products {
              ...PriceChangeFilterOptionBaseFields
            }
            shipFromWarehouseAreas {
              ...PriceChangeFilterOptionBaseFields
            }
            shipToLocations {
              ...PriceChangeFilterOptionBaseFields
            }
            productManagers {
              ...PriceChangeFilterOptionBaseFields
            }
          }
        }
        ... on GetPriceChangeFilterOptionsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangeHistory($input: GetPriceChangeHistoryInput!) {
    priceChange {
      getPriceChangeHistory(input: $input) {
        ... on GetPriceChangeHistorySuccess {
          priceChangeSubmissions {
            id
            changeId
            dateChanged
            reasonForUpdate
            status
            submittedById
            submittedBy {
              name
            }
            assignedToId
            assignedTo {
              name
            }
            dateChanged
            priceChangeItems {
              id
              product {
                ...PriceChangeProductFields
              }
              groups {
                ...PriceChangeItemGroupFields
              }
            }
            isRevertible
            revertOfId
            createdOn
            updatedOn
            productsAffectedCount
            customersAffectedCount
          }
        }
        ... on GetPriceChangeHistoryFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangeSubmission($input: GetPriceChangeSubmissionInput!) {
    priceChange {
      getPriceChangeSubmission(input: $input) {
        ... on GetPriceChangeSubmissionSuccess {
          priceChangeSubmission {
            id
            changeId
            changeType
            reasonForUpdate
            revertOfId
            dateChanged
            assignedToId
            submittedById
            isRevertible
            status
            source
            quoteRequest {
              id
              products {
                productId
                estimatedAnnualVolume
                pricePoint
              }
            }
            priceChangeItems {
              id
              product {
                ...PriceChangeProductFields
              }
              groups {
                ...PriceChangeItemGroupFields
              }
            }
          }
          # TODO: AK-6473 Create a fragment pageInfo and apply to all queries
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GetPriceChangeSubmissionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangeRecipients($input: GetPriceChangeRecipientsInput!) {
    priceChange {
      getPriceChangeRecipients(input: $input) {
        ... on GetPriceChangeRecipientsSuccess {
          recipients {
            companyId
            contactId
            companyName
            contactName
            email
          }
          totalContacts
          totalAccounts
        }
        ... on GetPriceChangeRecipientsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangePreviewPDF($input: GetPriceChangeNotificationPdfPreviewInput!) {
    priceChange {
      getPriceChangeNotificationPdfPreview(input: $input) {
        ... on GetPriceChangeNotificationPdfPreviewSuccess {
          signedUrl
        }
        ... on GetPriceChangeNotificationPdfPreviewFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
